/*
author: Umer Shabir.
file: doctor availability module: It will set time slots for doctor avaialabilty schedule.
date: 16-08-2022.
edited:12-09-2022.
updated: 25-10-2022.
*/
// dependencies
import React, { useEffect, useReducer, useState } from 'react'
import AddTimeSlot from './AddTimeSlot'
import axios from 'axios'
import { API_CONSTANTS } from '../../../../../../API_CONSTANTS'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import {
  faCheckCircle,
  faTimesCircle,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons'
import { getSession } from './sessionSlice'
import Toast from '../../../../../../Components/Toast/Toast'
import moment from 'moment'
import TextField from '@mui/material/TextField'
import Stack from '@mui/material/Stack'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import Loader from '../../../../../../Components/Loader/index.js'

let in_array = require('in_array')
// Availability Component
export default function SetTimeSlots() {
  // setting up all the states
  const params = useParams()
  const dispatch = useDispatch()
  // getting redux thunk state
  const { value, loading } = useSelector((state) => state.getSessionReducer)
  const [spin, setSpin] = useState()
  const [ToastMessage, setToastMessage] = useState('')
  const [showToast, setShowToast] = useState('')
  const [ToastIcon, setToastIcon] = useState(faTimesCircle)
  const [iconColor, setIconColor] = useState('')
  const [formDisable, setFormDisable] = useState({
    form: false,
    button: true,
  })
  // to update all the state asyncronously I am putting reducer function inside the component above the useReducer hook
  const formReducer = (state, action) => {
    switch (action.type) {
      case 'GET_DATA':
        // Extract video slots from nested structure
        const videoMonday = action.payload.video?.monday?.slots || []
        const videoTuesday = action.payload.video?.tuesday?.slots || []
        const videoWednesday = action.payload.video?.wednesday?.slots || []
        const videoThursday = action.payload.video?.thursday?.slots || []
        const videoFriday = action.payload.video?.friday?.slots || []
        const videoSaturday = action.payload.video?.saturday?.slots || []
        const videoSunday = action.payload.video?.sunday?.slots || []
        
        // Extract onsite slots from nested structure
        const onsiteMonday = action.payload.onsite?.monday?.slots || []
        const onsiteTuesday = action.payload.onsite?.tuesday?.slots || []
        const onsiteWednesday = action.payload.onsite?.wednesday?.slots || []
        const onsiteThursday = action.payload.onsite?.thursday?.slots || []
        const onsiteFriday = action.payload.onsite?.friday?.slots || []
        const onsiteSaturday = action.payload.onsite?.saturday?.slots || []
        const onsiteSunday = action.payload.onsite?.sunday?.slots || []
        
        return {
          ...state,
          chat: action.payload.chat === undefined ? false : action.payload.chat,
          video: action.payload.video === undefined ? true : action.payload.video,
          sundaySlots:
            action.payload.sundaySlots === undefined
              ? []
              : action.payload.sundaySlots
                .slice()
                .sort(
                  (a, b) => parseInt(a.startTime) - parseInt(b.startTime)
                ),
          saturday: action.payload.saturday === undefined ? false : action.payload.saturday,
          fridaySlots:
            action.payload.fridaySlots === undefined
              ? []
              : action.payload.fridaySlots
                .slice()
                .sort(
                  (a, b) => parseInt(a.startTime) - parseInt(b.startTime)
                ),
          tuesdaySlots:
            action.payload.tuesdaySlots === undefined
              ? []
              : action.payload.tuesdaySlots
                .slice()
                .sort(
                  (a, b) => parseInt(a.startTime) - parseInt(b.startTime)
                ),
          wednesdaySlots:
            action.payload.wednesdaySlots === undefined
              ? []
              : action.payload.wednesdaySlots
                .slice()
                .sort(
                  (a, b) => parseInt(a.startTime) - parseInt(b.startTime)
                ),
          thursday: action.payload.thursday === undefined ? false : action.payload.thursday,
          thursdaySlots:
            action.payload.thursdaySlots === undefined
              ? []
              : action.payload.thursdaySlots
                .slice()
                .sort(
                  (a, b) => parseInt(a.startTime) - parseInt(b.startTime)
                ),
          sunday: action.payload.sunday === undefined ? false : action.payload.sunday,
          tuesday: action.payload.tuesday === undefined ? false : action.payload.tuesday,
          mondaySlots:
            action.payload.mondaySlots === undefined
              ? []
              : action.payload.mondaySlots
                .slice()
                .sort(
                  (a, b) => parseInt(a.startTime) - parseInt(b.startTime)
                ),
          friday: action.payload.friday === undefined ? false : action.payload.friday,
          wednesday: action.payload.wednesday === undefined ? false : action.payload.wednesday,
          saturdaySlots:
            action.payload.saturdaySlots === undefined
              ? []
              : action.payload.saturdaySlots
                .slice()
                .sort(
                  (a, b) => parseInt(a.startTime) - parseInt(b.startTime)
                ),
          monday: action.payload.monday === undefined ? false : action.payload.monday,
          duration: action.payload.duration === undefined ? 10 : action.payload.duration,
          schedule: action.payload.schedule === undefined ? 7 : action.payload.schedule,
          chatAppointmentFee:
            action.payload.chatAppointmentFee === undefined
              ? 10
              : action.payload.chatAppointmentFee,
          videoAppointmentFee: action.payload.videoAppointmentFee,
          // Load new video/onsite fields from backend
          videoEnabled: action.payload.video?.enabled === undefined ? true : action.payload.video?.enabled,
          videoDuration: action.payload.video?.duration === undefined ? '' : action.payload.video?.duration,
          videoFee: action.payload.video?.fee === undefined ? '' : action.payload.video?.fee,
          onsiteEnabled: action.payload.onsite?.enabled === undefined ? false : action.payload.onsite?.enabled,
          onsiteDuration: action.payload.onsite?.duration === undefined ? '' : action.payload.onsite?.duration,
          onsiteFee: action.payload.onsite?.fee === undefined ? '' : action.payload.onsite?.fee,
          onsiteAddress: action.payload.onsite?.address === undefined ? '' : action.payload.onsite?.address,
          // Extract and sort all video slot arrays
          videoMondaySlots: videoMonday.length > 0 ? videoMonday.slice().sort((a, b) => parseInt(a.startTime) - parseInt(b.startTime)) : [],
          videoTuesdaySlots: videoTuesday.length > 0 ? videoTuesday.slice().sort((a, b) => parseInt(a.startTime) - parseInt(b.startTime)) : [],
          videoWednesdaySlots: videoWednesday.length > 0 ? videoWednesday.slice().sort((a, b) => parseInt(a.startTime) - parseInt(b.startTime)) : [],
          videoThursdaySlots: videoThursday.length > 0 ? videoThursday.slice().sort((a, b) => parseInt(a.startTime) - parseInt(b.startTime)) : [],
          videoFridaySlots: videoFriday.length > 0 ? videoFriday.slice().sort((a, b) => parseInt(a.startTime) - parseInt(b.startTime)) : [],
          videoSaturdaySlots: videoSaturday.length > 0 ? videoSaturday.slice().sort((a, b) => parseInt(a.startTime) - parseInt(b.startTime)) : [],
          videoSundaySlots: videoSunday.length > 0 ? videoSunday.slice().sort((a, b) => parseInt(a.startTime) - parseInt(b.startTime)) : [],
          // Extract and sort all onsite slot arrays
          onsiteMondaySlots: onsiteMonday.length > 0 ? onsiteMonday.slice().sort((a, b) => parseInt(a.startTime) - parseInt(b.startTime)) : [],
          onsiteTuesdaySlots: onsiteTuesday.length > 0 ? onsiteTuesday.slice().sort((a, b) => parseInt(a.startTime) - parseInt(b.startTime)) : [],
          onsiteWednesdaySlots: onsiteWednesday.length > 0 ? onsiteWednesday.slice().sort((a, b) => parseInt(a.startTime) - parseInt(b.startTime)) : [],
          onsiteThursdaySlots: onsiteThursday.length > 0 ? onsiteThursday.slice().sort((a, b) => parseInt(a.startTime) - parseInt(b.startTime)) : [],
          onsiteFridaySlots: onsiteFriday.length > 0 ? onsiteFriday.slice().sort((a, b) => parseInt(a.startTime) - parseInt(b.startTime)) : [],
          onsiteSaturdaySlots: onsiteSaturday.length > 0 ? onsiteSaturday.slice().sort((a, b) => parseInt(a.startTime) - parseInt(b.startTime)) : [],
          onsiteSundaySlots: onsiteSunday.length > 0 ? onsiteSunday.slice().sort((a, b) => parseInt(a.startTime) - parseInt(b.startTime)) : [],
          // Auto-enable video day toggles if slots exist
          videoMonday: videoMonday.length > 0,
          videoTuesday: videoTuesday.length > 0,
          videoWednesday: videoWednesday.length > 0,
          videoThursday: videoThursday.length > 0,
          videoFriday: videoFriday.length > 0,
          videoSaturday: videoSaturday.length > 0,
          videoSunday: videoSunday.length > 0,
          // Auto-enable onsite day toggles if slots exist
          onsiteMonday: onsiteMonday.length > 0,
          onsiteTuesday: onsiteTuesday.length > 0,
          onsiteWednesday: onsiteWednesday.length > 0,
          onsiteThursday: onsiteThursday.length > 0,
          onsiteFriday: onsiteFriday.length > 0,
          onsiteSaturday: onsiteSaturday.length > 0,
          onsiteSunday: onsiteSunday.length > 0,
        }
      case 'monday':
        return {
          ...state,
          mondaySlots: [...state.mondaySlots, action.payload],
        }
      case 'tuesday':
        return {
          ...state,
          tuesdaySlots: [...state.tuesdaySlots, action.payload],
        }
      case 'wednesday':
        return {
          ...state,
          wednesdaySlots: [...state.wednesdaySlots, action.payload],
        }
      case 'thursday':
        return {
          ...state,
          thursdaySlots: [...state.thursdaySlots, action.payload],
        }
      case 'friday':
        return {
          ...state,
          fridaySlots: [...state.fridaySlots, action.payload],
        }
      case 'saturday':
        return {
          ...state,
          saturdaySlots: [...state.saturdaySlots, action.payload],
        }
      case 'sunday':
        return {
          ...state,
          sundaySlots: [...state.sundaySlots, action.payload],
        }
      case 'monday_DELETE':
        return {
          ...state,
          mondaySlots: action.payload.data.filter(
            (item, index) => index !== action.payload.slot
          ),
        }
      case 'tuesday_DELETE':
        return {
          ...state,
          tuesdaySlots: action.payload.data.filter(
            (item, index) => index !== action.payload.slot
          ),
        }
      case 'wednesday_DELETE':
        return {
          ...state,
          wednesdaySlots: action.payload.data.filter(
            (item, index) => index !== action.payload.slot
          ),
        }
      case 'thursday_DELETE':
        return {
          ...state,
          thursdaySlots: action.payload.data.filter(
            (item, index) => index !== action.payload.slot
          ),
        }
      case 'friday_DELETE':
        return {
          ...state,
          fridaySlots: action.payload.data.filter(
            (item, index) => index !== action.payload.slot
          ),
        }
      case 'saturday_DELETE':
        return {
          ...state,
          saturdaySlots: action.payload.data.filter(
            (item, index) => index !== action.payload.slot
          ),
        }
      case 'sunday_DELETE':
        return {
          ...state,
          sundaySlots: action.payload.data.filter(
            (item, index) => index !== action.payload.slot
          ),
        }
      case 'monday_UPDATE': {
        return {
          ...state,
          mondaySlots: action.payload.data,
        }
      }
      case 'tuesday_UPDATE': {
        return {
          ...state,
          tuesdaySlots: action.payload.data,
        }
      }
      case 'wednesday_UPDATE': {
        return {
          ...state,
          wednesdaySlots: action.payload.data,
        }
      }
      case 'thursday_UPDATE': {
        return {
          ...state,
          thursdaySlots: action.payload.data,
        }
      }
      case 'friday_UPDATE': {
        return {
          ...state,
          fridaySlots: action.payload.data,
        }
      }
      case 'saturday_UPDATE': {
        return {
          ...state,
          saturdaySlots: action.payload.data,
        }
      }
      case 'sunday_UPDATE': {
        return {
          ...state,
          sundaySlots: action.payload.data,
        }
      }
      // VIDEO SLOTS
      case 'video_monday':
        return { ...state, videoMondaySlots: [...state.videoMondaySlots, action.payload], videoMonday: true }
      case 'video_tuesday':
        return { ...state, videoTuesdaySlots: [...state.videoTuesdaySlots, action.payload], videoTuesday: true }
      case 'video_wednesday':
        return { ...state, videoWednesdaySlots: [...state.videoWednesdaySlots, action.payload], videoWednesday: true }
      case 'video_thursday':
        return { ...state, videoThursdaySlots: [...state.videoThursdaySlots, action.payload], videoThursday: true }
      case 'video_friday':
        return { ...state, videoFridaySlots: [...state.videoFridaySlots, action.payload], videoFriday: true }
      case 'video_saturday':
        return { ...state, videoSaturdaySlots: [...state.videoSaturdaySlots, action.payload], videoSaturday: true }
      case 'video_sunday':
        return { ...state, videoSundaySlots: [...state.videoSundaySlots, action.payload], videoSunday: true }
      case 'video_monday_DELETE': {
        const updatedVideoMonday = action.payload.data.filter((item, index) => index !== action.payload.slot)
        return { ...state, videoMondaySlots: updatedVideoMonday, videoMonday: updatedVideoMonday.length > 0 }
      }
      case 'video_tuesday_DELETE': {
        const updatedVideoTuesday = action.payload.data.filter((item, index) => index !== action.payload.slot)
        return { ...state, videoTuesdaySlots: updatedVideoTuesday, videoTuesday: updatedVideoTuesday.length > 0 }
      }
      case 'video_wednesday_DELETE': {
        const updatedVideoWednesday = action.payload.data.filter((item, index) => index !== action.payload.slot)
        return { ...state, videoWednesdaySlots: updatedVideoWednesday, videoWednesday: updatedVideoWednesday.length > 0 }
      }
      case 'video_thursday_DELETE': {
        const updatedVideoThursday = action.payload.data.filter((item, index) => index !== action.payload.slot)
        return { ...state, videoThursdaySlots: updatedVideoThursday, videoThursday: updatedVideoThursday.length > 0 }
      }
      case 'video_friday_DELETE': {
        const updatedVideoFriday = action.payload.data.filter((item, index) => index !== action.payload.slot)
        return { ...state, videoFridaySlots: updatedVideoFriday, videoFriday: updatedVideoFriday.length > 0 }
      }
      case 'video_saturday_DELETE': {
        const updatedVideoSaturday = action.payload.data.filter((item, index) => index !== action.payload.slot)
        return { ...state, videoSaturdaySlots: updatedVideoSaturday, videoSaturday: updatedVideoSaturday.length > 0 }
      }
      case 'video_sunday_DELETE': {
        const updatedVideoSunday = action.payload.data.filter((item, index) => index !== action.payload.slot)
        return { ...state, videoSundaySlots: updatedVideoSunday, videoSunday: updatedVideoSunday.length > 0 }
      }
      case 'video_monday_UPDATE':
        return { ...state, videoMondaySlots: action.payload.data, videoMonday: action.payload.data.length > 0 }
      case 'video_tuesday_UPDATE':
        return { ...state, videoTuesdaySlots: action.payload.data, videoTuesday: action.payload.data.length > 0 }
      case 'video_wednesday_UPDATE':
        return { ...state, videoWednesdaySlots: action.payload.data, videoWednesday: action.payload.data.length > 0 }
      case 'video_thursday_UPDATE':
        return { ...state, videoThursdaySlots: action.payload.data, videoThursday: action.payload.data.length > 0 }
      case 'video_friday_UPDATE':
        return { ...state, videoFridaySlots: action.payload.data, videoFriday: action.payload.data.length > 0 }
      case 'video_saturday_UPDATE':
        return { ...state, videoSaturdaySlots: action.payload.data, videoSaturday: action.payload.data.length > 0 }
      case 'video_sunday_UPDATE':
        return { ...state, videoSundaySlots: action.payload.data, videoSunday: action.payload.data.length > 0 }
      // ONSITE SLOTS
      case 'onsite_monday':
        return { ...state, onsiteMondaySlots: [...state.onsiteMondaySlots, action.payload], onsiteMonday: true }
      case 'onsite_tuesday':
        return { ...state, onsiteTuesdaySlots: [...state.onsiteTuesdaySlots, action.payload], onsiteTuesday: true }
      case 'onsite_wednesday':
        return { ...state, onsiteWednesdaySlots: [...state.onsiteWednesdaySlots, action.payload], onsiteWednesday: true }
      case 'onsite_thursday':
        return { ...state, onsiteThursdaySlots: [...state.onsiteThursdaySlots, action.payload], onsiteThursday: true }
      case 'onsite_friday':
        return { ...state, onsiteFridaySlots: [...state.onsiteFridaySlots, action.payload], onsiteFriday: true }
      case 'onsite_saturday':
        return { ...state, onsiteSaturdaySlots: [...state.onsiteSaturdaySlots, action.payload], onsiteSaturday: true }
      case 'onsite_sunday':
        return { ...state, onsiteSundaySlots: [...state.onsiteSundaySlots, action.payload], onsiteSunday: true }
      case 'onsite_monday_DELETE': {
        const updatedOnsiteMonday = action.payload.data.filter((item, index) => index !== action.payload.slot)
        return { ...state, onsiteMondaySlots: updatedOnsiteMonday, onsiteMonday: updatedOnsiteMonday.length > 0 }
      }
      case 'onsite_tuesday_DELETE': {
        const updatedOnsiteTuesday = action.payload.data.filter((item, index) => index !== action.payload.slot)
        return { ...state, onsiteTuesdaySlots: updatedOnsiteTuesday, onsiteTuesday: updatedOnsiteTuesday.length > 0 }
      }
      case 'onsite_wednesday_DELETE': {
        const updatedOnsiteWednesday = action.payload.data.filter((item, index) => index !== action.payload.slot)
        return { ...state, onsiteWednesdaySlots: updatedOnsiteWednesday, onsiteWednesday: updatedOnsiteWednesday.length > 0 }
      }
      case 'onsite_thursday_DELETE': {
        const updatedOnsiteThursday = action.payload.data.filter((item, index) => index !== action.payload.slot)
        return { ...state, onsiteThursdaySlots: updatedOnsiteThursday, onsiteThursday: updatedOnsiteThursday.length > 0 }
      }
      case 'onsite_friday_DELETE': {
        const updatedOnsiteFriday = action.payload.data.filter((item, index) => index !== action.payload.slot)
        return { ...state, onsiteFridaySlots: updatedOnsiteFriday, onsiteFriday: updatedOnsiteFriday.length > 0 }
      }
      case 'onsite_saturday_DELETE': {
        const updatedOnsiteSaturday = action.payload.data.filter((item, index) => index !== action.payload.slot)
        return { ...state, onsiteSaturdaySlots: updatedOnsiteSaturday, onsiteSaturday: updatedOnsiteSaturday.length > 0 }
      }
      case 'onsite_sunday_DELETE': {
        const updatedOnsiteSunday = action.payload.data.filter((item, index) => index !== action.payload.slot)
        return { ...state, onsiteSundaySlots: updatedOnsiteSunday, onsiteSunday: updatedOnsiteSunday.length > 0 }
      }
      case 'onsite_monday_UPDATE':
        return { ...state, onsiteMondaySlots: action.payload.data, onsiteMonday: action.payload.data.length > 0 }
      case 'onsite_tuesday_UPDATE':
        return { ...state, onsiteTuesdaySlots: action.payload.data, onsiteTuesday: action.payload.data.length > 0 }
      case 'onsite_wednesday_UPDATE':
        return { ...state, onsiteWednesdaySlots: action.payload.data, onsiteWednesday: action.payload.data.length > 0 }
      case 'onsite_thursday_UPDATE':
        return { ...state, onsiteThursdaySlots: action.payload.data, onsiteThursday: action.payload.data.length > 0 }
      case 'onsite_friday_UPDATE':
        return { ...state, onsiteFridaySlots: action.payload.data, onsiteFriday: action.payload.data.length > 0 }
      case 'onsite_saturday_UPDATE':
        return { ...state, onsiteSaturdaySlots: action.payload.data, onsiteSaturday: action.payload.data.length > 0 }
      case 'onsite_sunday_UPDATE':
        return { ...state, onsiteSundaySlots: action.payload.data, onsiteSunday: action.payload.data.length > 0 }
      case 'isLegacy_UPDATE':
        return { ...state, isLegacy: action.payload }
      default:
        // Handle form input changes
        if (!action.target) {
          return state
        }
        try {
          const updatedState = {
            ...state,
            [action.target.name]:
              action.target.type === 'checkbox'
                ? action.target.checked
                : action.target.type === 'number'
                  ? parseInt(action.target.value)
                  : action.target.name === 'duration' ||
                    action.target.name === 'schedule'
                    ? parseInt(action.target.value)
                    : action.target.value,
          }
          return updatedState
        } catch (err) {
          return state
        }
    }
  }
  // initializing the useReducer hook for state management
  const [formData, setFormData] = useReducer(formReducer, {
    chat: false,
    video: true,
    isLegacy: false,
    // Legacy slots (kept for backward compatibility)
    sundaySlots: [],
    saturday: false,
    fridaySlots: [],
    tuesdaySlots: [],
    wednesdaySlots: [],
    thursday: false,
    thursdaySlots: [],
    sunday: false,
    tuesday: false,
    mondaySlots: [],
    friday: false,
    wednesday: false,
    saturdaySlots: [],
    monday: false,
    duration: '',
    schedule: '',
    chatAppointmentFee: 10,
    videoAppointmentFee: '',
    // New fields for separate video and onsite
    videoEnabled: true,
    videoDuration: '',
    videoFee: '',
    onsiteEnabled: false,
    onsiteDuration: '',
    onsiteFee: '',
    onsiteAddress: '',
    // Separate video slots for each day
    videoMondaySlots: [],
    videoTuesdaySlots: [],
    videoWednesdaySlots: [],
    videoThursdaySlots: [],
    videoFridaySlots: [],
    videoSaturdaySlots: [],
    videoSundaySlots: [],
    // Separate onsite slots for each day
    onsiteMondaySlots: [],
    onsiteTuesdaySlots: [],
    onsiteWednesdaySlots: [],
    onsiteThursdaySlots: [],
    onsiteFridaySlots: [],
    onsiteSaturdaySlots: [],
    onsiteSundaySlots: [],
    // Video day toggles
    videoMonday: false,
    videoTuesday: false,
    videoWednesday: false,
    videoThursday: false,
    videoFriday: false,
    videoSaturday: false,
    videoSunday: false,
    // Onsite day toggles
    onsiteMonday: false,
    onsiteTuesday: false,
    onsiteWednesday: false,
    onsiteThursday: false,
    onsiteFriday: false,
    onsiteSaturday: false,
    onsiteSunday: false,
  })
  // extracting all the values from Reducer to update the state
  const {
    chat,
    video,
    isLegacy,
    sundaySlots,
    saturday,
    fridaySlots,
    tuesdaySlots,
    wednesdaySlots,
    thursday,
    thursdaySlots,
    sunday,
    tuesday,
    mondaySlots,
    friday,
    wednesday,
    saturdaySlots,
    monday,
    duration,
    schedule,
    chatAppointmentFee,
    videoAppointmentFee,
    videoEnabled,
    videoDuration,
    videoFee,
    onsiteEnabled,
    onsiteDuration,
    onsiteFee,
    onsiteAddress,
    // Video slots
    videoMondaySlots,
    videoTuesdaySlots,
    videoWednesdaySlots,
    videoThursdaySlots,
    videoFridaySlots,
    videoSaturdaySlots,
    videoSundaySlots,
    // Onsite slots
    onsiteMondaySlots,
    onsiteTuesdaySlots,
    onsiteWednesdaySlots,
    onsiteThursdaySlots,
    onsiteFridaySlots,
    onsiteSaturdaySlots,
    onsiteSundaySlots,
    // Video day toggles
    videoMonday,
    videoTuesday,
    videoWednesday,
    videoThursday,
    videoFriday,
    videoSaturday,
    videoSunday,
    // Onsite day toggles
    onsiteMonday,
    onsiteTuesday,
    onsiteWednesday,
    onsiteThursday,
    onsiteFriday,
    onsiteSaturday,
    onsiteSunday,
  } = formData

  // an array to map all the weeks for legacy data
  const weekName = [
    {
      name: 'monday',
      check: monday,
      Slots: mondaySlots,
      id: 0,
    },
    {
      name: 'tuesday',
      check: tuesday,
      Slots: tuesdaySlots,
      id: 1,
    },
    {
      name: 'wednesday',
      check: wednesday,
      Slots: wednesdaySlots,
      id: 2,
    },
    {
      name: 'thursday',
      check: thursday,
      Slots: thursdaySlots,
      id: 3,
    },
    {
      name: 'friday',
      check: friday,
      Slots: fridaySlots,
      id: 4,
    },
    {
      name: 'saturday',
      check: saturday,
      Slots: saturdaySlots,
      id: 5,
    },
    {
      name: 'sunday',
      check: sunday,
      Slots: sundaySlots,
      id: 6,
    },
  ]

  // Video Appointment Time Slots
  const videoWeekName = [
    {
      name: 'monday',
      displayName: 'Monday',
      check: videoMonday,
      Slots: videoMondaySlots,
      id: 0,
    },
    {
      name: 'tuesday',
      displayName: 'Tuesday',
      check: videoTuesday,
      Slots: videoTuesdaySlots,
      id: 1,
    },
    {
      name: 'wednesday',
      displayName: 'Wednesday',
      check: videoWednesday,
      Slots: videoWednesdaySlots,
      id: 2,
    },
    {
      name: 'thursday',
      displayName: 'Thursday',
      check: videoThursday,
      Slots: videoThursdaySlots,
      id: 3,
    },
    {
      name: 'friday',
      displayName: 'Friday',
      check: videoFriday,
      Slots: videoFridaySlots,
      id: 4,
    },
    {
      name: 'saturday',
      displayName: 'Saturday',
      check: videoSaturday,
      Slots: videoSaturdaySlots,
      id: 5,
    },
    {
      name: 'sunday',
      displayName: 'Sunday',
      check: videoSunday,
      Slots: videoSundaySlots,
      id: 6,
    },
  ]

  // Onsite Appointment Time Slots
  const onsiteWeekName = [
    {
      name: 'monday',
      displayName: 'Monday',
      check: onsiteMonday,
      Slots: onsiteMondaySlots,
      id: 0,
    },
    {
      name: 'tuesday',
      displayName: 'Tuesday',
      check: onsiteTuesday,
      Slots: onsiteTuesdaySlots,
      id: 1,
    },
    {
      name: 'wednesday',
      displayName: 'Wednesday',
      check: onsiteWednesday,
      Slots: onsiteWednesdaySlots,
      id: 2,
    },
    {
      name: 'thursday',
      displayName: 'Thursday',
      check: onsiteThursday,
      Slots: onsiteThursdaySlots,
      id: 3,
    },
    {
      name: 'friday',
      displayName: 'Friday',
      check: onsiteFriday,
      Slots: onsiteFridaySlots,
      id: 4,
    },
    {
      name: 'saturday',
      displayName: 'Saturday',
      check: onsiteSaturday,
      Slots: onsiteSaturdaySlots,
      id: 5,
    },
    {
      name: 'sunday',
      displayName: 'Sunday',
      check: onsiteSunday,
      Slots: onsiteSundaySlots,
      id: 6,
    },
  ]

  // Toast function
  const handleToast = (message, icon, iconColor, className) => {
    setToastIcon(icon)
    setToastMessage(message)
    setShowToast(`show ${className}`)
    setIconColor(iconColor)
    setTimeout(() => setShowToast(''), 2900)
  }
  // add time slot callback function
  const addTimeSlot = async (data, itemIndex, appointmentType = 'legacy', weekArray = weekName) => {
    setFormData({
      type: `${appointmentType}_${weekArray[itemIndex].name}`,
      payload: data,
    })
  }

  // handle delete function
  const handleDelete = (data, name, slot, appointmentType = 'legacy') => {
    setFormData({ type: `${appointmentType}_${name}_DELETE`, payload: { data, name, slot } })
    setFormDisable(prev => ({ ...prev, button: false }))
    
    // Show notification that user needs to save
    handleToast(
      'Time slot deleted. Click Save to persist changes.',
      faCheckCircle,
      '#FF9800',
      'show-success'
    )
  }
  // updating the timeslot object
  const handleUpdateSlot = (
    currentValue,
    slots,
    lastValue,
    name,
    currentSlot,
    slotIndex,
    appointmentType = 'legacy'
  ) => {
    if (currentSlot.startTime === lastValue) {
      let updatedSlots = slots.map((item, index) => {
        if (index === slotIndex) {
          return { ...item, startTime: currentValue }
        }
        return item
      })
      setFormData({
        type: `${appointmentType}_${name}_UPDATE`,
        payload: {
          data: updatedSlots,
        },
      })
    } else {
      let updatedSlots = slots.map((item, index) => {
        if (index === slotIndex) {
          return { ...item, endTime: currentValue }
        }
        return item
      })
      setFormData({
        type: `${appointmentType}_${name}_UPDATE`,
        payload: {
          data: updatedSlots,
        },
      })
    }
  }
  // submiting the data
  const handleSubmit = (e) => {
    try {
      e.preventDefault()
      setSpin('spinner-border spinner-border-sm')
      setFormDisable({
        form: true,
        button: true,
      })

    // Transform form data to backend format
    const dayNames = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
    
    // Build schedule data in correct nested format
    const buildScheduleData = (dayNames, slotsMap, dayToggleMap = {}, forceDisabled = false) => {
      const scheduleObj = {}
      dayNames.forEach((day) => {
        const slots = slotsMap[day] || []
        const dayEnabled = !forceDisabled && !!dayToggleMap[day] && slots.length > 0
        scheduleObj[day] = {
          enabled: dayEnabled,
          slots: dayEnabled ? slots : [],
        }
      })
      return scheduleObj
    }
    
    // Video slots map
    const videoSlotsMap = {
      monday: Array.isArray(videoMondaySlots) ? videoMondaySlots : [],
      tuesday: Array.isArray(videoTuesdaySlots) ? videoTuesdaySlots : [],
      wednesday: Array.isArray(videoWednesdaySlots) ? videoWednesdaySlots : [],
      thursday: Array.isArray(videoThursdaySlots) ? videoThursdaySlots : [],
      friday: Array.isArray(videoFridaySlots) ? videoFridaySlots : [],
      saturday: Array.isArray(videoSaturdaySlots) ? videoSaturdaySlots : [],
      sunday: Array.isArray(videoSundaySlots) ? videoSundaySlots : [],
    }

    // Onsite slots map
    const onsiteSlotsMap = {
      monday: Array.isArray(onsiteMondaySlots) ? onsiteMondaySlots : [],
      tuesday: Array.isArray(onsiteTuesdaySlots) ? onsiteTuesdaySlots : [],
      wednesday: Array.isArray(onsiteWednesdaySlots) ? onsiteWednesdaySlots : [],
      thursday: Array.isArray(onsiteThursdaySlots) ? onsiteThursdaySlots : [],
      friday: Array.isArray(onsiteFridaySlots) ? onsiteFridaySlots : [],
      saturday: Array.isArray(onsiteSaturdaySlots) ? onsiteSaturdaySlots : [],
      sunday: Array.isArray(onsiteSundaySlots) ? onsiteSundaySlots : [],
    }

    const videoDayToggleMap = {
      monday: videoMonday,
      tuesday: videoTuesday,
      wednesday: videoWednesday,
      thursday: videoThursday,
      friday: videoFriday,
      saturday: videoSaturday,
      sunday: videoSunday,
    }

    const onsiteDayToggleMap = {
      monday: onsiteMonday,
      tuesday: onsiteTuesday,
      wednesday: onsiteWednesday,
      thursday: onsiteThursday,
      friday: onsiteFriday,
      saturday: onsiteSaturday,
      sunday: onsiteSunday,
    }

    // Build payload in CORRECT nested format expected by backend
    const payload = {
      video: {
        enabled: !!videoEnabled,
        fee: videoFee ? parseInt(videoFee) : 0,
        duration: videoDuration ? parseInt(videoDuration) : 0,
      },
      chat: {
        enabled: !!chat
      },
      onsite: {
        enabled: !!onsiteEnabled,
        fee: onsiteFee ? parseInt(onsiteFee) : 0,
        duration: onsiteDuration ? parseInt(onsiteDuration) : 0,
        address: onsiteAddress || '',
      }
    }

    payload.video = {
      ...payload.video,
      ...buildScheduleData(dayNames, videoSlotsMap, videoDayToggleMap, !videoEnabled)
    }

    payload.onsite = {
      ...payload.onsite,
      ...buildScheduleData(dayNames, onsiteSlotsMap, onsiteDayToggleMap, !onsiteEnabled)
    }

    axios
      .patch(
        `${API_CONSTANTS.BASEURL}admin/doctors/${params.id}/sessions`,
        payload,
        {
          headers: API_CONSTANTS.headers(),
        }
      )
      .then((res) => {
        handleToast(
          res.data.response.message,
          faCheckCircle,
          '#009b94',
          'show-success'
        )
        setSpin('')
        // Refresh the session data to display updated slots
        dispatch(getSession(params.id))
      })
      .then(() =>
        setFormDisable({
          form: false,
          button: true,
        })
      )
      .catch((e) => {
        handleToast(
          e.response?.data?.response?.message
            ? e.response.data.response.message
            : 'Something is get wrong',
          faExclamationTriangle,
          'ffffff',
          'show-danger'
        )
        setSpin(false)
        setFormDisable({
          form: false,
          button: false,
        })
      })
    } catch (err) {
      handleToast(
        'An unexpected error occurred',
        faExclamationTriangle,
        'ffffff',
        'show-danger'
      )
      setSpin(false)
      setFormDisable({
        form: false,
        button: false,
      })
    }
  }
  // dispatching action to the redux thunk to fetch previous data
  useEffect(() => {
    dispatch(getSession(params.id))
  }, [])

  // Load the fetched data into the form reducer
  useEffect(() => {
    if (value && Object.keys(value).length > 0) {
      setFormData({ 
        type: 'GET_DATA',
        payload: value
      })
    }
  }, [value])

  // Monitor formData changes for debugging
  useEffect(() => {
    // Validate all slot arrays are arrays
    const slotArrays = [
      'videoMondaySlots', 'videoTuesdaySlots', 'videoWednesdaySlots', 
      'videoThursdaySlots', 'videoFridaySlots', 'videoSaturdaySlots', 'videoSundaySlots',
      'onsiteMondaySlots', 'onsiteTuesdaySlots', 'onsiteWednesdaySlots',
      'onsiteThursdaySlots', 'onsiteFridaySlots', 'onsiteSaturdaySlots', 'onsiteSundaySlots'
    ]
  }, [formData])

  return (
    <>
      {loading && <Loader />}
      <div className='row m-4 rounded p-2'>
        <div className='col-12'>
          <div className='d-flex'>
            <form
              onSubmit={handleSubmit}
              className='w-100'
              onChange={() => setFormDisable(prev => ({ ...prev, button: false }))}
              style={{ cursor: formDisable.form ? 'no-drop' : '' }}
            >
              <fieldset
                disabled={formDisable.form}
                style={{ cursor: formDisable.form ? 'no-drop' : '' }}
              >
                {/* VIDEO APPOINTMENT SECTION */}
                <div className='d-flex justify-content-between rounded p-3 bg-light mb-3 align-items-center'>
                  <div className='d-flex align-items-center' style={{ flex: 1 }}>
                    <div className='form-check form-switch'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        id='videoEnabled'
                        name='videoEnabled'
                        checked={videoEnabled}
                        onChange={setFormData}
                      />
                      <label className='form-check-label' htmlFor='videoEnabled'>
                        <strong>Enable Video Appointments</strong>
                      </label>
                    </div>
                  </div>
                  {videoEnabled && (
                    <>
                      <div className='d-flex flex-column w-25 px-3'>
                        <label htmlFor='videoDuration'>Duration (minutes)</label>
                        <select
                          name='videoDuration'
                          id='videoDuration'
                          className='bg-light border-bottom form-select'
                          value={videoDuration}
                          onChange={setFormData}
                          style={{
                            cursor: formDisable.form ? 'no-drop' : '',
                          }}
                        >
                          <option value=''>Select Duration</option>
                          <option value='10'>10 minutes</option>
                          <option value='15'>15 minutes</option>
                          <option value='20'>20 minutes</option>
                          <option value='25'>25 minutes</option>
                          <option value='30'>30 minutes</option>
                          <option value='35'>35 minutes</option>
                          <option value='40'>40 minutes</option>
                          <option value='45'>45 minutes</option>
                          <option value='50'>50 minutes</option>
                          <option value='55'>55 minutes</option>
                          <option value='60'>60 minutes</option>
                        </select>
                      </div>
                      <div className='d-flex flex-column w-25 px-3'>
                        <label htmlFor='videoFee'>Fee (Rs)</label>
                        <input
                          type='number'
                          name='videoFee'
                          id='videoFee'
                          className='bg-light border-bottom form-control'
                          placeholder='Ex 500'
                          value={videoFee}
                          onChange={setFormData}
                          style={{
                            cursor: formDisable.form ? 'no-drop' : '',
                          }}
                        />
                      </div>
                    </>
                  )}
                </div>

                {/* ONSITE APPOINTMENT SECTION */}
                <div className='d-flex justify-content-between rounded p-3 bg-light mb-3 align-items-center flex-wrap'>
                  <div className='d-flex align-items-center' style={{ flex: 1 }}>
                    <div className='form-check form-switch'>
                      <input
                        className='form-check-input'
                        type='checkbox'
                        id='onsiteEnabled'
                        name='onsiteEnabled'
                        checked={onsiteEnabled}
                        onChange={setFormData}
                      />
                      <label className='form-check-label' htmlFor='onsiteEnabled'>
                        <strong>Enable Onsite Appointments</strong>
                      </label>
                    </div>
                  </div>
                  {onsiteEnabled && (
                    <>
                      <div className='d-flex flex-column w-25 px-3'>
                        <label htmlFor='onsiteDuration'>Duration (minutes)</label>
                        <select
                          name='onsiteDuration'
                          id='onsiteDuration'
                          className='bg-light border-bottom form-select'
                          value={onsiteDuration}
                          onChange={setFormData}
                          style={{
                            cursor: formDisable.form ? 'no-drop' : '',
                          }}
                        >
                          <option value=''>Select Duration</option>
                          <option value='10'>10 minutes</option>
                          <option value='15'>15 minutes</option>
                          <option value='20'>20 minutes</option>
                          <option value='25'>25 minutes</option>
                          <option value='30'>30 minutes</option>
                          <option value='35'>35 minutes</option>
                          <option value='40'>40 minutes</option>
                          <option value='45'>45 minutes</option>
                          <option value='50'>50 minutes</option>
                          <option value='55'>55 minutes</option>
                          <option value='60'>60 minutes</option>
                        </select>
                      </div>
                      <div className='d-flex flex-column w-25 px-3'>
                        <label htmlFor='onsiteFee'>Fee (Rs)</label>
                        <input
                          type='number'
                          name='onsiteFee'
                          id='onsiteFee'
                          className='bg-light border-bottom form-control'
                          placeholder='Ex 1000'
                          value={onsiteFee}
                          onChange={setFormData}
                          style={{
                            cursor: formDisable.form ? 'no-drop' : '',
                          }}
                        />
                      </div>
                      <div className='d-flex flex-column w-100 px-3 mt-3'>
                        <label htmlFor='onsiteAddress'>Clinic Address</label>
                        <input
                          type='text'
                          name='onsiteAddress'
                          id='onsiteAddress'
                          className='bg-light border-bottom form-control'
                          placeholder='Ex: Clinic 5, Blue Area, Islamabad'
                          value={onsiteAddress}
                          onChange={setFormData}
                          style={{
                            cursor: formDisable.form ? 'no-drop' : '',
                          }}
                        />
                      </div>
                    </>
                  )}
                </div>
              </fieldset>

              {/* LEGACY TIME SLOTS SECTION - COMMENTED OUT */}
              {false && (
                <fieldset
                  className='d-flex flex-column bg-light rounded mb-3'
                  disabled={formDisable.form}
                  style={{ cursor: formDisable.form ? 'no-drop' : 'default' }}
                >
                  <div className='p-3 bg-light' style={{ borderBottom: '2px solid #009b94' }}>
                    <div className='d-flex justify-content-between align-items-center'>
                      <h5 style={{ color: '#009b94', marginBottom: 0 }}>Legacy Time Slots</h5>
                      <div className='form-check form-switch'>
                        <input
                          type='checkbox'
                          className='form-check-input'
                          id='legacyToggle'
                          name='isLegacy'
                          checked={isLegacy}
                          onChange={(e) => {
                            setFormData({
                              type: 'isLegacy_UPDATE',
                              payload: e.target.checked,
                            })
                          }}
                          style={{
                            cursor: formDisable.form ? 'no-drop' : 'pointer',
                          }}
                        />
                        <label className='form-check-label' htmlFor='legacyToggle' style={{ marginBottom: 0 }}>
                          {isLegacy ? 'Enabled' : 'Disabled'}
                        </label>
                      </div>
                    </div>
                  </div>
                  {weekName.map((item, index) => (
                  <fieldset
                    className='d-flex w-100 border-bottom'
                    key={index}
                    disabled={formDisable.form}
                    style={{ cursor: formDisable.form ? 'no-drop' : 'default' }}
                  >
                    <div className='w-25 d-flex justify-content-between align-items-start form-check form-switch p-3'>
                      <label htmlFor='monday' className='form-check-label'>
                        {item.name.slice(0, 1).toUpperCase() +
                          item.name.slice(1)}
                      </label>
                      <input
                        type='checkbox'
                        className='form-check-input'
                        name={item.name}
                        onChange={setFormData}
                        checked={item.check}
                        style={{
                          cursor: formDisable.form ? 'no-drop' : 'default',
                        }}
                      />
                    </div>
                    <fieldset
                      className='w-75 d-flex justify-content-between align-items-start p-3'
                      style={{
                        background: '#E0F3F2',
                        cursor: formDisable.form ? 'no-drop' : 'default',
                        flexDirection: 'column-reverse',
                      }}
                      disabled={item.check === true ? false : true}
                      onClick={() =>
                        setFormDisable(prev => ({ ...prev, button: false }))
                      }
                    >
                      <div className='d-flex flex-column time-slot-responsive w-100'>
                        {item.Slots === undefined
                          ? []
                          : item.Slots.map((slot, index) => (
                            <div
                              key={index}
                              className='d-flex align-items-center w-100 my-1'
                              style={{ columnGap: 20 }}
                            >
                              <div className='d-flex my-1 align-items-center'>
                                <span
                                  className='me-3'
                                  style={{ width: '30px' }}
                                >
                                  {index + 1}.
                                </span>
                                <span>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack spacing={3}>
                                      <TimePicker
                                        slotProps={{
                                          textField: {
                                            fullWidth: true,
                                            size: 'small',
                                            variant: 'outlined',
                                          },
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            fullWidth
                                            size='small'
                                            variant='outlined'
                                          />
                                        )}
                                        value={
                                          slot.startTime !== ''
                                            ? new Date(
                                              0,
                                              0,
                                              0,
                                              slot.startTime !== undefined
                                                ? moment(
                                                  moment().format(
                                                    'MM/DD/YYYY'
                                                  ) +
                                                  ' ' +
                                                  slot.startTime
                                                ).hour()
                                                : 0,
                                              moment(
                                                moment().format(
                                                  'MM/DD/YYYY'
                                                ) +
                                                ' ' +
                                                slot.startTime
                                              ).minute()
                                            )
                                            : null
                                        }
                                        label='Start Time'
                                        onChange={(e) => {
                                          handleUpdateSlot(
                                            moment(e.$d).format('HH:mm'),
                                            item.Slots,
                                            slot.startTime,
                                            item.name,
                                            slot,
                                            index
                                          )
                                        }}
                                        minutesStep={5}
                                        disabled={
                                          formDisable.form === true
                                            ? true
                                            : false || item.check === true
                                              ? false
                                              : true
                                        }
                                        style={{
                                          cursor: formDisable.form
                                            ? 'no-drop'
                                            : 'default',
                                        }}
                                        shouldDisableTime={(
                                          timeValue,
                                          clockType
                                        ) => {
                                          let disableTimes = []
                                          let disableTimeSlots = []

                                          if (item.Slots.length > 1) {
                                            item.Slots.map((item) => {
                                              if (
                                                slot.startTime < item.endTime
                                              ) {
                                                let openingTime =
                                                  item.startTime.slice(0, 2)
                                                let closingTime =
                                                  item.endTime.slice(0, 2)
                                                disableTimeSlots.push({
                                                  start: item.startTime,
                                                  end: item.endTime,
                                                })
                                                // while (
                                                //   openingTime <= closingTime
                                                // ) {
                                                //   if (openingTime !== '') {
                                                //     disableTimes.push(
                                                //       openingTime.toString()
                                                //     )
                                                //     disableTimes.sort(
                                                //       (a, b) => a - b
                                                //     )
                                                //   }
                                                //   console.log(disableTimes)
                                                //   openingTime++
                                                // }
                                              }
                                            })
                                            // console.log(
                                            //   item.Slots[
                                            //     item.Slots.length - 2
                                            //   ]
                                            // )
                                            //debugger;
                                            if (
                                              index ===
                                              item.Slots.length - 1 &&
                                              slot.startTime <
                                              item.Slots[
                                                item.Slots.length - 2
                                              ].endTime
                                            ) {
                                              let currentValue =
                                                parseInt(timeValue)
                                              if (clockType === 'hours') {
                                                let availableMinutes = 60
                                                disableTimeSlots.forEach(
                                                  function (
                                                    timeSlot,
                                                    index,
                                                    arr
                                                  ) {
                                                    let startHr = parseInt(
                                                      timeSlot.start.slice(
                                                        0,
                                                        2
                                                      )
                                                    )
                                                    let endHr = parseInt(
                                                      timeSlot.end.slice(0, 2)
                                                    )

                                                    if (
                                                      currentValue >=
                                                      startHr &&
                                                      currentValue <= endHr
                                                    ) {
                                                      let startTime = ''
                                                      let endTime = ''
                                                      if (
                                                        currentValue > startHr
                                                      ) {
                                                        startTime = moment(
                                                          currentValue +
                                                          ':00',
                                                          'hh:mm'
                                                        )
                                                      } else {
                                                        startTime = moment(
                                                          timeSlot.start,
                                                          'hh:mm'
                                                        )
                                                      }
                                                      if (
                                                        endHr > currentValue
                                                      ) {
                                                        endTime = moment(
                                                          currentValue +
                                                          1 +
                                                          ':00',
                                                          'hh:mm'
                                                        )
                                                      } else {
                                                        endTime = moment(
                                                          timeSlot.end,
                                                          'hh:mm'
                                                        )
                                                      }
                                                      availableMinutes =
                                                        availableMinutes -
                                                        Math.abs(
                                                          endTime.diff(
                                                            startTime,
                                                            'minutes'
                                                          )
                                                        )
                                                    }
                                                  }
                                                )
                                                if (availableMinutes <= 0) {
                                                  return true
                                                }
                                              }
                                              if (clockType === 'minutes') {
                                                let disableMinutes = false
                                                disableTimeSlots.forEach(
                                                  function (
                                                    timeSlot,
                                                    index,
                                                    arr
                                                  ) {
                                                    let temp =
                                                      moment().format(
                                                        'YYYY-MM-DD'
                                                      )
                                                    disableMinutes = moment(
                                                      temp +
                                                      ' ' +
                                                      slot.startTime.slice(
                                                        0,
                                                        2
                                                      ) +
                                                      ':' +
                                                      currentValue
                                                    ).isBetween(
                                                      temp +
                                                      ' ' +
                                                      timeSlot.start,
                                                      temp +
                                                      ' ' +
                                                      timeSlot.end
                                                    )
                                                  }
                                                )
                                                return disableMinutes
                                              }
                                            }
                                            //  if (
                                            //    index ===
                                            //    item.Slots.length - 1 && slot.startTime <
                                            //  ) {
                                            //    return (
                                            //      clockType === 'hours' &&
                                            //      in_array(
                                            //        timeValue,
                                            //        disableTimes
                                            //      )
                                            //    )
                                            //  }
                                          }
                                          // console.log(
                                          //   slot.startTime.slice(0, 2)
                                          // )
                                          // console.log(
                                          //   slot.endTime.slice(0, 2)
                                          // )
                                          // let openingTime =
                                          //   slot.startTime.slice(0, 2)
                                          // let closingTime =
                                          //   slot.endTime.slice(0, 2)
                                          // while (openingTime <= closingTime) {
                                          //   disableTimes.push(
                                          //     openingTime.toString()
                                          //   )
                                          //   console.log(disableTimes)
                                          //   openingTime++
                                          // }

                                          // if (item.Slots.length !== 1) {
                                          //   item.Slots.map((item, index) => {
                                          //     let openingTime = item.startTime
                                          //     let endingtime = item.endTime
                                          //     console.log(openingTime)
                                          //   })
                                          //   return (
                                          //     clockType === 'hours' &&
                                          //     !in_array(
                                          //       timeValue,
                                          //       disableTimes
                                          //     )
                                          //   )
                                          // }
                                        }}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </span>
                                <p className='m-0 mx-2'>to</p>
                                <span>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <Stack spacing={3}>
                                      <TimePicker
                                        slotProps={{
                                          textField: {
                                            fullWidth: true,
                                            size: 'small',
                                            variant: 'outlined',
                                          },
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            fullWidth
                                            size='small'
                                            variant='outlined'
                                          />
                                        )}
                                        value={
                                          slot.endTime !== ''
                                            ? new Date(
                                              0,
                                              0,
                                              0,
                                              slot.endTime !== undefined
                                                ? moment(
                                                  moment().format(
                                                    'MM/DD/YYYY'
                                                  ) +
                                                  ' ' +
                                                  slot.endTime
                                                ).hour()
                                                : 0,
                                              moment(
                                                moment().format(
                                                  'MM/DD/YYYY'
                                                ) +
                                                ' ' +
                                                slot.endTime
                                              ).minute()
                                            )
                                            : null
                                        }
                                        label='End Time'
                                        onChange={(e) => {
                                          handleUpdateSlot(
                                            moment(e.$d).format('HH:mm'),
                                            item.Slots,
                                            slot.endTime,
                                            item.name,
                                            slot,
                                            index
                                          )
                                        }}
                                        minutesStep={5}
                                        disabled={
                                          formDisable.form === true
                                            ? true
                                            : false || item.check === true
                                              ? false
                                              : true
                                        }
                                        style={{
                                          cursor: formDisable.form
                                            ? 'no-drop'
                                            : 'default',
                                        }}
                                        shouldDisableTime={(
                                          timeValue,
                                          clockType
                                        ) => {
                                          let x = {
                                            slotInterval: duration,
                                            openTime:
                                              slot.startTime !== ''
                                                ? new Date(
                                                  0,
                                                  0,
                                                  0,
                                                  slot.startTime !==
                                                    undefined
                                                    ? moment(
                                                      moment().format(
                                                        'MM/DD/YYYY'
                                                      ) +
                                                      ' ' +
                                                      slot.startTime
                                                    ).hour()
                                                    : 0,
                                                  moment(
                                                    moment().format(
                                                      'MM/DD/YYYY'
                                                    ) +
                                                    ' ' +
                                                    slot.startTime
                                                  ).minute()
                                                )
                                                : null,
                                            closeTime:
                                              slot.endTime !== ''
                                                ? new Date(
                                                  0,
                                                  0,
                                                  0,
                                                  slot.endTime !== undefined
                                                    ? moment(
                                                      moment().format(
                                                        'MM/DD/YYYY'
                                                      ) +
                                                      ' ' +
                                                      slot.endTime
                                                    ).hour()
                                                    : 0,
                                                  moment(
                                                    moment().format(
                                                      'MM/DD/YYYY'
                                                    ) +
                                                    ' ' +
                                                    slot.endTime
                                                  ).minute()
                                                )
                                                : null,
                                          }
                                          let allTimes = []
                                          let startTime = moment(
                                            x.openTime,
                                            'HH:mm'
                                          )
                                          let endTime = moment(
                                            x.closeTime,
                                            'HH:mm'
                                          ).add(1, 'hours')
                                          let activeHour = moment(
                                            slot.endTime !== ''
                                              ? new Date(
                                                0,
                                                0,
                                                0,
                                                slot.endTime !== undefined
                                                  ? moment(
                                                    moment().format(
                                                      'MM/DD/YYYY'
                                                    ) +
                                                    ' ' +
                                                    slot.endTime
                                                  ).hour()
                                                  : 0,
                                                moment(
                                                  moment().format(
                                                    'MM/DD/YYYY'
                                                  ) +
                                                  ' ' +
                                                  slot.endTime
                                                ).minute()
                                              )
                                              : null
                                          ).format('HH')

                                          while (startTime < endTime) {
                                            if (
                                              activeHour ===
                                              startTime.format('HH')
                                            ) {
                                              allTimes.push(
                                                startTime.format('mm')
                                              )
                                            }
                                            startTime.add(
                                              x.slotInterval,
                                              'minutes'
                                            )
                                          }
                                          if (
                                            moment(x.openTime).format(
                                              'HH'
                                            ) ===
                                            moment(x.closeTime).format('HH')
                                          ) {
                                            allTimes.splice(0, 1)
                                          }
                                          return (
                                            clockType === 'minutes' &&
                                            !in_array(timeValue, allTimes)
                                          )
                                        }}
                                      />
                                    </Stack>
                                  </LocalizationProvider>
                                </span>
                              </div>
                              <div
                                className='d-flex'
                                style={{ columnGap: '20px' }}
                              >
                                <div>
                                  <input
                                    type='checkbox'
                                    checked={slot.video}
                                    readOnly
                                    className='form-check-input mx-2'
                                    style={{
                                      cursor: formDisable.form
                                        ? 'no-drop'
                                        : '',
                                    }}
                                  />
                                  <label
                                    htmlFor='videoChat'
                                    className='form-check-label '
                                    style={{ color: '#5C5C5C' }}
                                  >
                                    {' '}
                                    <i className='fas fa-video'></i>
                                  </label>
                                </div>
                                <div>
                                  <input
                                    type='checkbox'
                                    defaultChecked={slot.chat}
                                    disabled
                                    className='form-check-input mx-2'
                                    style={{
                                      cursor: formDisable.form
                                        ? 'no-drop'
                                        : '',
                                    }}
                                  />
                                  <label
                                    htmlFor='Chat'
                                    className='form-check-label'
                                    style={{ color: '#5C5C5C' }}
                                  >
                                    <i className='fas fa-comment-medical'></i>
                                  </label>
                                </div>
                              </div>
                              <div>
                                {/* <deleteTimeSlot /> */}
                                <button
                                  type='button'
                                  className=' btn'
                                  style={{
                                    color: '#FF6760',
                                    cursor: formDisable.form ? 'no-drop' : 'pointer',
                                  }}
                                  disabled={formDisable.form}
                                  onClick={() =>
                                    handleDelete(item.Slots, item.name, index)
                                  }
                                >
                                  <i className='fas fa-trash-alt'></i>
                                </button>
                              </div>
                            </div>
                          ))}
                      </div>
                      <div className='d-flex justify-content-end w-100'>
                        <AddTimeSlot
                          addTimeSlot={addTimeSlot}
                          itemIndex={item.id}
                          item={item}
                          duration={duration}
                          activeForm={setFormDisable}
                        />
                      </div>
                    </fieldset>
                  </fieldset>
                ))}
                </fieldset>
              )}

              {/* VIDEO APPOINTMENT TIME SLOTS SECTION */}
              {videoEnabled && (
                <fieldset
                  className='d-flex flex-column bg-light rounded mb-3'
                  disabled={formDisable.form}
                  style={{ cursor: formDisable.form ? 'no-drop' : 'default' }}
                >
                  <div className='p-3 bg-light' style={{ borderBottom: '2px solid #009b94' }}>
                    <h5 style={{ color: '#009b94', marginBottom: 0 }}> Video Appointment Time Slots</h5>
                  </div>
                  <div className='d-flex justify-content-between rounded p-3 bg-light align-items-center' style={{ borderBottom: '1px solid #e0e0e0' }}>
                    <div className='d-flex flex-column w-25 px-3'>
                      <label htmlFor='videoSchedule'>Schedule Valid For</label>
                      <select
                        name='schedule'
                        id='videoSchedule'
                        className='bg-light border-bottom form-select'
                        value={schedule}
                        onChange={setFormData}
                        style={{
                          cursor: formDisable.form ? 'no-drop' : '',
                        }}
                      >
                        <option value='7'>7 days</option>
                        <option value='14'>14 days</option>
                        <option value='21'>21 days</option>
                        <option value='28'>28 days</option>
                      </select>
                    </div>
                    <div className='d-flex flex-column w-25 px-3'>
                      <label htmlFor='videoDurationField'>Duration of Appointment</label>
                      <select
                        name='videoDuration'
                        id='videoDurationField'
                        className='bg-light border-bottom form-select'
                        value={videoDuration}
                        onChange={setFormData}
                        style={{
                          cursor: formDisable.form ? 'no-drop' : '',
                        }}
                      >
                        <option value=''>Select Duration</option>
                        <option value='10'>10 minutes</option>
                        <option value='15'>15 minutes</option>
                        <option value='20'>20 minutes</option>
                        <option value='25'>25 minutes</option>
                        <option value='30'>30 minutes</option>
                        <option value='35'>35 minutes</option>
                        <option value='40'>40 minutes</option>
                        <option value='45'>45 minutes</option>
                        <option value='50'>50 minutes</option>
                        <option value='55'>55 minutes</option>
                        <option value='60'>60 minutes</option>
                      </select>
                    </div>
                    <div className='d-flex flex-column w-25 px-3'>
                      <label htmlFor='videoFeeField'>Video Appointment Fee</label>
                      <input
                        type='number'
                        name='videoFee'
                        id='videoFeeField'
                        className='bg-light border-bottom form-control'
                        placeholder='Ex 500 Rs'
                        value={videoFee}
                        onChange={setFormData}
                        style={{
                          cursor: formDisable.form ? 'no-drop' : '',
                        }}
                      />
                    </div>
                    <div className='d-flex flex-column w-25 px-3'>
                      <label htmlFor='chatFeeVideo'>Online Chat Fee</label>
                      <input
                        type='number'
                        name='chatAppointmentFee'
                        id='chatFeeVideo'
                        className='bg-light border-bottom form-control'
                        placeholder='Ex 200 Rs'
                        value={chatAppointmentFee}
                        onChange={setFormData}
                        disabled
                        style={{
                          cursor: formDisable.form ? 'no-drop' : '',
                        }}
                      />
                    </div>
                  </div>
                  {videoWeekName.map((item, index) => (
                    <div key={`video-${index}`} className='d-flex w-100 border-bottom' style={{ minHeight: '70px' }}>
                      {/* Day Name + Toggle */}
                      <div className='w-25 d-flex justify-content-between align-items-center p-3' style={{ borderRight: '1px solid #e0e0e0' }}>
                        <label style={{ marginBottom: 0, fontWeight: '500', color: '#333' }}>
                          {item.displayName}
                        </label>
                        <div className='form-check form-switch' style={{ marginLeft: 'auto' }}>
                          <input
                            type='checkbox'
                            className='form-check-input'
                            id={`video-toggle-${item.name}`}
                            name={`video${item.displayName}`}
                            onChange={(e) => {
                              setFormData({
                                target: {
                                  name: `video${item.displayName}`,
                                  type: 'checkbox',
                                  checked: e.target.checked,
                                },
                              })
                            }}
                            checked={item.check}
                            style={{
                              cursor: formDisable.form ? 'no-drop' : 'pointer',
                            }}
                          />
                        </div>
                      </div>
                      
                      {/* Time Slots Section */}
                      {item.check ? (
                        <div className='w-75 p-3' style={{ background: '#E0F3F2' }} onClick={() => setFormDisable(prev => ({ ...prev, button: false }))}>
                          {item.Slots === undefined || item.Slots.length === 0 ? (
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <span style={{ color: '#999', fontSize: '14px' }}>No time slots added</span>
                              <AddTimeSlot
                                addTimeSlot={addTimeSlot}
                                itemIndex={item.id}
                                item={item}
                                duration={videoDuration}
                                activeForm={setFormDisable}
                                appointmentType='video'
                                weekArray={videoWeekName}
                              />
                            </div>
                          ) : (
                            <div>
                              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '15px' }}>
                                {item.Slots.map((slot, slotIndex) => (
                                  <div key={slotIndex} className='d-flex align-items-center justify-content-between' style={{ padding: '10px', background: 'white', borderRadius: '4px', gap: '10px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1 }}>
                                      <span style={{ fontWeight: 'bold', minWidth: '25px' }}>{slotIndex + 1}.</span>
                                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Stack spacing={2} direction='row'>
                                          <TimePicker
                                            value={
                                              slot.startTime !== ''
                                                ? new Date(0, 0, 0, moment(moment().format('MM/DD/YYYY') + ' ' + slot.startTime).hour(), moment(moment().format('MM/DD/YYYY') + ' ' + slot.startTime).minute())
                                                : null
                                            }
                                            label='Start'
                                            onChange={(e) => {
                                              handleUpdateSlot(moment(e.$d).format('HH:mm'), item.Slots, slot.startTime, item.name, slot, slotIndex, 'video')
                                            }}
                                            minutesStep={5}
                                            disabled={formDisable.form}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                size='small'
                                                variant='outlined'
                                                fullWidth
                                              />
                                            )}
                                          />
                                          <p style={{ margin: '0 5px' }}>to</p>
                                          <TimePicker
                                            value={
                                              slot.endTime !== ''
                                                ? new Date(0, 0, 0, moment(moment().format('MM/DD/YYYY') + ' ' + slot.endTime).hour(), moment(moment().format('MM/DD/YYYY') + ' ' + slot.endTime).minute())
                                                : null
                                            }
                                            label='End'
                                            onChange={(e) => {
                                              handleUpdateSlot(moment(e.$d).format('HH:mm'), item.Slots, slot.endTime, item.name, slot, slotIndex, 'video')
                                            }}
                                            minutesStep={5}
                                            disabled={formDisable.form}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                size='small'
                                                variant='outlined'
                                                fullWidth
                                              />
                                            )}
                                          />
                                        </Stack>
                                      </LocalizationProvider>
                                    </div>
                                    <button
                                      type='button'
                                      className='btn btn-sm'
                                      style={{ color: '#FF6760', padding: '5px 10px' }}
                                      disabled={formDisable.form}
                                      onClick={() => handleDelete(item.Slots, item.name, slotIndex, 'video')}
                                    >
                                      <i className='fas fa-trash-alt'></i>
                                    </button>
                                  </div>
                                ))}
                              </div>
                              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <AddTimeSlot
                                  addTimeSlot={addTimeSlot}
                                  itemIndex={item.id}
                                  item={item}
                                  duration={videoDuration}
                                  activeForm={setFormDisable}
                                  appointmentType='video'
                                  weekArray={videoWeekName}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className='w-75 p-3 d-flex align-items-center' style={{ background: '#f9f9f9', color: '#999' }}>
                          <span style={{ fontSize: '14px' }}>Enable to add time slots</span>
                        </div>
                      )}
                    </div>
                  ))}
                </fieldset>
              )}

              {/* ONSITE APPOINTMENT TIME SLOTS SECTION */}
              {onsiteEnabled && (
                <fieldset
                  className='d-flex flex-column bg-light rounded mb-3'
                  disabled={formDisable.form}
                  style={{ cursor: formDisable.form ? 'no-drop' : 'default' }}
                >
                  <div className='p-3 bg-light' style={{ borderBottom: '2px solid #FF6760' }}>
                    <h5 style={{ color: '#FF6760', marginBottom: 0 }}> Onsite Appointment Time Slots</h5>
                  </div>
                  <div className='d-flex justify-content-between rounded p-3 bg-light align-items-center' style={{ borderBottom: '1px solid #e0e0e0' }}>
                    <div className='d-flex flex-column w-25 px-3'>
                      <label htmlFor='onsiteSchedule'>Schedule Valid For</label>
                      <select
                        name='schedule'
                        id='onsiteSchedule'
                        className='bg-light border-bottom form-select'
                        value={schedule}
                        onChange={setFormData}
                        style={{
                          cursor: formDisable.form ? 'no-drop' : '',
                        }}
                      >
                        <option value='7'>7 days</option>
                        <option value='14'>14 days</option>
                        <option value='21'>21 days</option>
                        <option value='28'>28 days</option>
                      </select>
                    </div>
                    <div className='d-flex flex-column w-25 px-3'>
                      <label htmlFor='onsiteDurationField'>Duration of Appointment</label>
                      <select
                        name='onsiteDuration'
                        id='onsiteDurationField'
                        className='bg-light border-bottom form-select'
                        value={onsiteDuration}
                        onChange={setFormData}
                        style={{
                          cursor: formDisable.form ? 'no-drop' : '',
                        }}
                      >
                        <option value=''>Select Duration</option>
                        <option value='10'>10 minutes</option>
                        <option value='15'>15 minutes</option>
                        <option value='20'>20 minutes</option>
                        <option value='25'>25 minutes</option>
                        <option value='30'>30 minutes</option>
                        <option value='35'>35 minutes</option>
                        <option value='40'>40 minutes</option>
                        <option value='45'>45 minutes</option>
                        <option value='50'>50 minutes</option>
                        <option value='55'>55 minutes</option>
                        <option value='60'>60 minutes</option>
                      </select>
                    </div>
                    <div className='d-flex flex-column w-25 px-3'>
                      <label htmlFor='onsiteFeeField'>Onsite Appointment Fee</label>
                      <input
                        type='number'
                        name='onsiteFee'
                        id='onsiteFeeField'
                        className='bg-light border-bottom form-control'
                        placeholder='Ex 1000 Rs'
                        value={onsiteFee}
                        onChange={setFormData}
                        style={{
                          cursor: formDisable.form ? 'no-drop' : '',
                        }}
                      />
                    </div>
                    <div className='d-flex flex-column w-25 px-3'>
                      <label htmlFor='onsiteAddressField'>Clinic Address</label>
                      <input
                        type='text'
                        name='onsiteAddress'
                        id='onsiteAddressField'
                        className='bg-light border-bottom form-control'
                        placeholder='Ex: Clinic 5, Blue Area'
                        value={onsiteAddress}
                        onChange={setFormData}
                        style={{
                          cursor: formDisable.form ? 'no-drop' : '',
                        }}
                      />
                    </div>
                  </div>
                  {onsiteWeekName.map((item, index) => (
                    <div key={`onsite-${index}`} className='d-flex w-100 border-bottom' style={{ minHeight: '70px' }}>
                      {/* Day Name + Toggle */}
                      <div className='w-25 d-flex justify-content-between align-items-center p-3' style={{ borderRight: '1px solid #e0e0e0' }}>
                        <label style={{ marginBottom: 0, fontWeight: '500', color: '#333' }}>
                          {item.displayName}
                        </label>
                        <div className='form-check form-switch' style={{ marginLeft: 'auto' }}>
                          <input
                            type='checkbox'
                            className='form-check-input'
                            id={`onsite-toggle-${item.name}`}
                            name={`onsite${item.displayName}`}
                            onChange={(e) => {
                              setFormData({
                                target: {
                                  name: `onsite${item.displayName}`,
                                  type: 'checkbox',
                                  checked: e.target.checked,
                                },
                              })
                            }}
                            checked={item.check}
                            style={{
                              cursor: formDisable.form ? 'no-drop' : 'pointer',
                            }}
                          />
                        </div>
                      </div>
                      
                      {/* Time Slots Section */}
                      {item.check ? (
                        <div className='w-75 p-3' style={{ background: '#FFE8E5' }} onClick={() => setFormDisable(prev => ({ ...prev, button: false }))}>
                          {item.Slots === undefined || item.Slots.length === 0 ? (
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <span style={{ color: '#999', fontSize: '14px' }}>No time slots added</span>
                              <AddTimeSlot
                                addTimeSlot={addTimeSlot}
                                itemIndex={item.id}
                                item={item}
                                duration={onsiteDuration}
                                activeForm={setFormDisable}
                                appointmentType='onsite'
                                weekArray={onsiteWeekName}
                              />
                            </div>
                          ) : (
                            <div>
                              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '15px' }}>
                                {item.Slots.map((slot, slotIndex) => (
                                  <div key={slotIndex} className='d-flex align-items-center justify-content-between' style={{ padding: '10px', background: 'white', borderRadius: '4px', gap: '10px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px', flex: 1 }}>
                                      <span style={{ fontWeight: 'bold', minWidth: '25px' }}>{slotIndex + 1}.</span>
                                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <Stack spacing={2} direction='row'>
                                          <TimePicker
                                            slotProps={{
                                              textField: {
                                                size: 'small',
                                                variant: 'outlined',
                                              },
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                size='small'
                                                variant='outlined'
                                                fullWidth
                                              />
                                            )}
                                            value={
                                              slot.startTime !== ''
                                                ? new Date(0, 0, 0, moment(moment().format('MM/DD/YYYY') + ' ' + slot.startTime).hour(), moment(moment().format('MM/DD/YYYY') + ' ' + slot.startTime).minute())
                                                : null
                                            }
                                            label='Start'
                                            onChange={(e) => {
                                              handleUpdateSlot(moment(e.$d).format('HH:mm'), item.Slots, slot.startTime, item.name, slot, slotIndex, 'onsite')
                                            }}
                                            minutesStep={5}
                                            disabled={formDisable.form}
                                          />
                                          <p style={{ margin: '0 5px' }}>to</p>
                                          <TimePicker
                                            slotProps={{
                                              textField: {
                                                size: 'small',
                                                variant: 'outlined',
                                              },
                                            }}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                size='small'
                                                variant='outlined'
                                                fullWidth
                                              />
                                            )}
                                            value={
                                              slot.endTime !== ''
                                                ? new Date(0, 0, 0, moment(moment().format('MM/DD/YYYY') + ' ' + slot.endTime).hour(), moment(moment().format('MM/DD/YYYY') + ' ' + slot.endTime).minute())
                                                : null
                                            }
                                            label='End'
                                            onChange={(e) => {
                                              handleUpdateSlot(moment(e.$d).format('HH:mm'), item.Slots, slot.endTime, item.name, slot, slotIndex, 'onsite')
                                            }}
                                            minutesStep={5}
                                            disabled={formDisable.form}
                                          />
                                        </Stack>
                                      </LocalizationProvider>
                                    </div>
                                    <button
                                      type='button'
                                      className='btn btn-sm'
                                      style={{ color: '#FF6760', padding: '5px 10px' }}
                                      disabled={formDisable.form}
                                      onClick={() => handleDelete(item.Slots, item.name, slotIndex, 'onsite')}
                                    >
                                      <i className='fas fa-trash-alt'></i>
                                    </button>
                                  </div>
                                ))}
                              </div>
                              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <AddTimeSlot
                                  addTimeSlot={addTimeSlot}
                                  itemIndex={item.id}
                                  item={item}
                                  duration={onsiteDuration}
                                  activeForm={setFormDisable}
                                  appointmentType='onsite'
                                  weekArray={onsiteWeekName}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className='w-75 p-3 d-flex align-items-center' style={{ background: '#f9f9f9', color: '#999' }}>
                          <span style={{ fontSize: '14px' }}>Enable to add time slots</span>
                        </div>
                      )}
                    </div>
                  ))}
                </fieldset>
              )}

              <div
                className='d-flex w-100 justify-content-end '
                style={{ columnGap: '10px' }}
              >
                {/* <button
                  className='btn'
                  type='submit'
                  style={{
                    border: '1px solid #009B94',
                    color: '#009B94',
                    padding: '5px 50px',
                  }}
                >
                  Reset
                </button> */}
                <button
                  className='btn d-flex align-items-center'
                  style={{
                    background: '#009B94',
                    color: '#fff',
                    padding: '5px 50px',
                    cursor: formDisable.form ? 'no-drop' : '',
                  }}
                  type='submit'
                  disabled={formDisable.button}
                >
                  Save
                  <span className={spin} />
                </button>
              </div>
            </form>
          </div>
        </div>
        <Toast
          cName={showToast}
          icon={ToastIcon}
          color={iconColor}
          text={ToastMessage}
        />
        <style jsx='true'>{`
          /* Chrome, Safari, Edge, Opera */
          input::-webkit-outer-spin-button,
          input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }

          /* Firefox */
          input[type='number'] {
            -moz-appearance: textfield;
          }
          .custom-button:hover {
            text-decoration: underline;
          }
          .form-check-input:checked {
            background-color: #009b94;
            border-color: #009b94;
          }
          .form-select:focus {
            border-color: #009b94;
            outline: 0;
            box-shadow: 0 0 0 0.25rem rgb(0 155 148 / 30%);
          }
          .form-control:focus {
            border-color: #009b94;
            outline: 0;
            box-shadow: 0 0 0 0.25rem rgb(0 155 148 / 30%);
          }

          select:selection {
            background-color: red;
            color: white;
          }
          .mouse-cursor {
            cursor: no-drop;
          }
          .time-slot-responsive {
            width: 50%;
          }
          @media only screen and (max-width: 1600px) {
            .time-slot-responsive {
              width: 70%;
            }
          }
        `}</style>
      </div>
    </>
  )
}
